import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { tdClass, badgeBaseClass } from '@/lib/tableStyles'
import type { ConsultationListItem } from '../../types/clinical'

const CONSULT_STATUS_CLASSES: Record<string, string> = {
  open: 'bg-warning-bg text-warning-text',
  completed: 'bg-success-bg text-success-text',
}

export function ConsultationRow({ c }: { c: ConsultationListItem }) {
  const badgeExtra = CONSULT_STATUS_CLASSES[c.status] ?? ''
  return (
    <tr>
      <td className={tdClass}>
        <Link
          to={`/consultations/${c.id}`}
          className="text-accent font-medium no-underline hover:underline"
        >
          {c.reason ?? '(no reason)'}
        </Link>
      </td>
      <td className={tdClass}>{new Date(c.date).toLocaleDateString()}</td>
      <td className={tdClass}>{c.practice_name ?? '—'}</td>
      <td className={tdClass}>{c.veterinarian_name ?? '—'}</td>
      <td className={tdClass}>
        <span className={cn(badgeBaseClass, badgeExtra)}>
          {c.status.charAt(0).toUpperCase() + c.status.slice(1)}
        </span>
      </td>
      <td className={cn(tdClass, 'text-right')}>
        <Link to={`/patients/${c.patient_id}`} className="text-text-3 text-[0.8rem] no-underline hover:underline">
          View Patient →
        </Link>
      </td>
    </tr>
  )
}
